module.exports = __webpack_public_path__ + "assets/img/fb-icon.b905a0d5.svg";